export default __webpack_public_path__ + "static/media/dados-figura3.06a5c047.png";